import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["onClick", "selected", "isActive"];
import React from "react";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export var DEFAULT_SOCIAL_BUTTON = {
  type: "UPDOWNVOTE",
  fakeCount: 0,
  userOnly: false,
  registerLightboxId: null
};

/**
 * @typedef {typeof VOTE_RESET | typeof VOTE_UP | typeof VOTE_DOWN} VOTE_ENUM
 */

export var VOTE_RESET = 0;
export var VOTE_UP = 1;
export var VOTE_DOWN = -1;
var VOTE_NAMES = _defineProperty(_defineProperty(_defineProperty({}, VOTE_RESET, "reset"), VOTE_UP, "up"), VOTE_DOWN, "down");
var createButton = function createButton(theme, iconDefault, iconActive) {
  return function (_ref) {
    var onClick = _ref.onClick,
      selected = _ref.selected,
      isActive = _ref.isActive,
      props = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/_jsxs("button", _objectSpread(_objectSpread({
      onClick: onClick,
      className: "vote-button ".concat(isActive ? "active" : "", " vote-button-").concat(theme, " vote-button-state-").concat(VOTE_NAMES[selected])
    }, props), {}, {
      children: [/*#__PURE__*/_jsx("div", {
        className: "default",
        children: iconDefault
      }), /*#__PURE__*/_jsx("div", {
        className: "active",
        children: iconActive
      })]
    }));
  };
};

/**
 * Button that shows a plus sign or a smiley, if active
 * @protected works only with VoteBar and CSS
 * @param {VoteButtonProps} param0
 */
var UpVoteButton = createButton("up", /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("i", {
    className: "glyphicon glyphicon-arrow-up"
  }), " ", /*#__PURE__*/_jsx("span", {
    children: "Huiii"
  })]
}), /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("img", {
    src: "/img/smile-g.png"
  }), " ", /*#__PURE__*/_jsx("span", {
    children: "Huiii"
  })]
}));

/**
 * Button that shows a plus sign or a smiley, if active
 * @protected works only with VoteBar and CSS
 * @param {VoteButtonProps} param0
 */
var DownVoteButton = createButton("down", /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("i", {
    className: "glyphicon glyphicon-arrow-down"
  }), " ", /*#__PURE__*/_jsx("span", {
    children: "Pfuiii"
  })]
}), /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("img", {
    src: "/img/cry-d.png"
  }), " ", /*#__PURE__*/_jsx("span", {
    children: "Pfuiii"
  })]
}));

/**
 * @param {{
 *  className?: string,
 *  onUpClick: (ev: React.SyntheticEvent) => void,
 *  onDownClick: (ev: React.SyntheticEvent) => void,
 *  selected: VOTE_ENUM,
 *  sum: Number,
 *  buttonProps?: VoteButtonProps,
 *  upProps?: VoteButtonProps,
 *  downProps?: VoteButtonProps
 * }} param0
 */
export var VoteBar = function VoteBar(_ref2) {
  var _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? "" : _ref2$className,
    onUpClick = _ref2.onUpClick,
    onDownClick = _ref2.onDownClick,
    sum = _ref2.sum,
    selected = _ref2.selected,
    _ref2$buttonProps = _ref2.buttonProps,
    buttonProps = _ref2$buttonProps === void 0 ? {} : _ref2$buttonProps,
    _ref2$upProps = _ref2.upProps,
    upProps = _ref2$upProps === void 0 ? {} : _ref2$upProps,
    _ref2$downProps = _ref2.downProps,
    downProps = _ref2$downProps === void 0 ? {} : _ref2$downProps;
  return /*#__PURE__*/_jsxs("div", {
    className: "vote-bar ".concat(className),
    children: [/*#__PURE__*/_jsx(UpVoteButton, _objectSpread(_objectSpread({}, _objectSpread(_objectSpread({}, buttonProps || {}), upProps || {})), {}, {
      isActive: selected === VOTE_UP,
      selected: selected,
      onClick: onUpClick
    })), /*#__PURE__*/_jsx("div", {
      className: "vote-bar-count ".concat(sum < 0 ? "negative" : ""),
      children: sum
    }), /*#__PURE__*/_jsx(DownVoteButton, _objectSpread(_objectSpread({}, _objectSpread(_objectSpread({}, buttonProps || {}), downProps || {})), {}, {
      isActive: selected === VOTE_DOWN,
      selected: selected,
      onClick: onDownClick
    }))]
  });
};
export var VoteStatsBar = function VoteStatsBar(_ref3) {
  var ups = _ref3.ups,
    downs = _ref3.downs;
  var sum = ups + downs;
  var percUp = ups / sum * 100;
  // using flex, it is more precise to let the downs grow accordingly.
  return /*#__PURE__*/_jsxs("div", {
    className: "vote-stats-bar",
    children: [/*#__PURE__*/_jsx("div", {
      className: "vote-stats-bar-ups",
      style: {
        width: "".concat(percUp, "%")
      }
    }), /*#__PURE__*/_jsx("div", {
      className: "vote-stats-bar-downs"
    })]
  });
};

/**
 * computes the state after the value changed
 *
 * @param {VOTE_ENUM} prevValue the value the user previously was checked
 * @param {VOTE_ENUM} nextValue the value that should be applied next
 * @param {number} sum cumulated ups and downs.
 * @param {number} ups number of ups
 * @param {number} downs number of downs
 * @return {{sum: number, ups:number, downs:number, count: number, selected: VOTE_ENUM}}
 */
export var update = function update() {
  var prevValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : VOTE_RESET;
  var nextValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : VOTE_RESET;
  var sum = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var ups = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var downs = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  // same values means we want to toggle to a resetted state
  if (prevValue === nextValue) {
    nextValue = VOTE_RESET;
  }
  // remove previous value
  sum -= prevValue;
  if (prevValue === VOTE_DOWN) {
    downs--;
  } else if (prevValue === VOTE_UP) {
    ups--;
  }
  // add new value
  sum += nextValue;
  if (nextValue === VOTE_UP) {
    ups++;
  } else if (nextValue === VOTE_DOWN) {
    downs++;
  }
  var selected = nextValue;
  return {
    sum: sum,
    selected: selected,
    downs: downs,
    ups: ups,
    count: ups + downs
  };
};
//# sourceMappingURL=VoteBar.js.map